export default "__VITE_ASSET__fda11f49__"